import { gql } from '@apollo/client';

export const verifyTelegramAuthMutation = gql`
    mutation VerifyTelegramAuth($sessionId: String!, $initDataRaw: String!) {
        verifyTelegramAuth(sessionId: $sessionId, initDataRaw: $initDataRaw)
    }
`;
